import { ItiBaseEditor } from './../iti-base-editor';
import { Component, Model, Prop, Ref, Watch } from 'vue-property-decorator';
import { ValidationProvider } from 'vee-validate';
@Component({
    components: {
        ValidationProvider,
    },
})
export default class ItiRadioButton extends ItiBaseEditor {
    @Prop() public items!: any[];
    @Model('value-radioButton-change') public model!: string;

    public valueRadioButton = '';

    public set value(newValue: string) {
        this.$emit('value-radioButton-change', newValue);
    }
    public get value() {
        return this.model;
    }

}
